import React from "react";
import styled, { css } from "styled-components";

// context
import { useSiteHeader } from "core/SiteHeader/context/useSiteHeader.js";

// Drop Down
import { DropDownProvider, Hotspot } from "core/DropDown/index.js";

// data
import { primaryMenu } from "data/links";
import { trackheaderToolsClicked } from "core/trackEvent.js";

// components
import DropDown from "./DropDown";

// styles
import { linkStyles } from "core/SiteHeader/components/Link";
import { convertPxToRem } from "frontend/components/helpers";

const ToolsStyled = styled.div`
    display: inline-block;
    margin: 0rem ${convertPxToRem(8)};
`;

const HostSpotStyled = styled(Hotspot)`
    ${({ $isDarkMode }) => {
        return css`
            ${linkStyles($isDarkMode)}
        `;
    }};
`;

// component
export const Tools = () => {
    const {
        viewport: { isDesktop },
        isDarkMode
    } = useSiteHeader();

    return (
        <ToolsStyled>
            <DropDownProvider
                id="tools-menu"
                isDarkMode={isDarkMode}
                hasCloseButton={false}
                hideOnScroll
                width={isDesktop ? 1074 : 600}
                top={20}
                padding={24}
                alignment="center"
                zIndex={2}
                onOpen={trackheaderToolsClicked}
                hasTriangle
            >
                <HostSpotStyled $isDarkMode={isDarkMode}>
                    {primaryMenu.products.links.tools.name}
                </HostSpotStyled>
                <DropDown />
            </DropDownProvider>
        </ToolsStyled>
    );
};

export default Tools;
